import { render } from "./IngredientCheckNotice.vue?vue&type=template&id=108caffb&scoped=true"
import script from "./IngredientCheckNotice.vue?vue&type=script&lang=js"
export * from "./IngredientCheckNotice.vue?vue&type=script&lang=js"

import "./IngredientCheckNotice.vue?vue&type=style&index=0&id=108caffb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108caffb"]])

export default __exports__